/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseContactUploadBatchResponse } from '../../models/api-response-contact-upload-batch-response';

export interface UploadContacts$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: string
}

export function uploadContacts(http: HttpClient, rootUrl: string, params: UploadContacts$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseContactUploadBatchResponse>> {
  const rb = new RequestBuilder(rootUrl, uploadContacts.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseContactUploadBatchResponse>;
    })
  );
}

uploadContacts.PATH = '/v1/api/ui/contacts/upload';
